/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type DashboardDropDown_report = {
    readonly categories: {
        readonly airtime: {
            readonly " $fragmentRefs": FragmentRefs<"DashboardDropDown_category">;
        } | null;
        readonly data: {
            readonly " $fragmentRefs": FragmentRefs<"DashboardDropDown_category">;
        } | null;
        readonly entertainment: {
            readonly " $fragmentRefs": FragmentRefs<"DashboardDropDown_category">;
        } | null;
        readonly ticketing: {
            readonly " $fragmentRefs": FragmentRefs<"DashboardDropDown_category">;
        } | null;
        readonly billPayments: {
            readonly " $fragmentRefs": FragmentRefs<"DashboardDropDown_category">;
        } | null;
        readonly electricity: {
            readonly " $fragmentRefs": FragmentRefs<"DashboardDropDown_category">;
        } | null;
        readonly other: {
            readonly " $fragmentRefs": FragmentRefs<"DashboardDropDown_category">;
        } | null;
    };
    readonly " $refType": "DashboardDropDown_report";
};
export type DashboardDropDown_report$data = DashboardDropDown_report;
export type DashboardDropDown_report$key = {
    readonly " $data"?: DashboardDropDown_report$data;
    readonly " $fragmentRefs": FragmentRefs<"DashboardDropDown_report">;
};



const node: ReaderFragment = (function(){
var v0 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "DashboardDropDown_category"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DashboardDropDown_report",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DetailedSalesReportCategories",
      "kind": "LinkedField",
      "name": "categories",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "DetailedSalesReportCategory",
          "kind": "LinkedField",
          "name": "airtime",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DetailedSalesReportCategory",
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DetailedSalesReportCategory",
          "kind": "LinkedField",
          "name": "entertainment",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DetailedSalesReportCategory",
          "kind": "LinkedField",
          "name": "ticketing",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DetailedSalesReportCategory",
          "kind": "LinkedField",
          "name": "billPayments",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DetailedSalesReportCategory",
          "kind": "LinkedField",
          "name": "electricity",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DetailedSalesReportCategory",
          "kind": "LinkedField",
          "name": "other",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DetailedSalesReport",
  "abstractKey": null
};
})();
(node as any).hash = '20b8de438ecfe5b50ab9ba69d2b236df';
export default node;
